/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

import { useEffect } from 'react'
import Header from '../components/Header.jsx'
import Hero from '../components/Hero.jsx'
import About from '../components/About.jsx'
import Team from '../components/Team.jsx'
import Programs from '../components/Programs.jsx'
import BeforeAfter from '../components/BeforeAfter.jsx'
import Pricing from '../components/Pricing.jsx'
import VideoSection from '../components/VideoSection.jsx'
import ArticleGrid from '../components/ArticleGrid.jsx'
import Faq from '../components/Faq.jsx'
import Footer from '../components/Footer.jsx'
import TabBar from '../components/TabBar.jsx'
import Fab from '../components/Fab.jsx'
import MobileMenu from '../components/MobileMenu.jsx'
import useScrollPath from '../hooks/useScrollPath.js'
import useMotion from '../hooks/useMotion.js'

export default function Home() {
  useScrollPath()
  useMotion()

  useEffect(() => {
    window.addEventListener('pageshow', (e) => {
      if (e.persisted && !location.hash) window.scrollTo(0, 0)
    })
    if (!location.hash) window.scrollTo(0, 0)
  }, [])

  return (
    <>
      <svg id="seq-path" aria-hidden="true" focusable="false">
        <path id="seq-p1" d="" />
      </svg>
      <Header />
      <main className="lp-main lp-root">
        <Hero />
        <About />
        <Team />
        <Programs />
        <BeforeAfter />
        <div className="lp-pricing" id="pricing">
          <div className="lp-pricing-in">
            <div className="lp-pricing-w" id="pricing-cont">
              <div className="lp-pricing-wc">
                <Pricing />
              </div>
            </div>
          </div>
        </div>
        <ArticleGrid />
        <VideoSection />
      </main>
      <Faq />
      <Footer />
      <TabBar />
      <Fab />
      <MobileMenu />
      <svg id="seq-path-top" aria-hidden="true" focusable="false">
        <path id="seq-f1" d="" />
        <path id="seq-f2" d="" />
      </svg>
    </>
  )
}
